import moment from "moment"

export const couponApi = () => process.env.REACT_APP_BACKEND_URL + "/v1/admin/coupon"
export const channelLabel = channel => ({ line_man: "LINE MAN", grab: "Grab" }[channel] || channel)
export const displayDate = value => value ? moment(value).format("YYYY-MM-DD HH:mm") : "No limit"
export const inputDate = value => value ? moment(value).format("YYYY-MM-DDTHH:mm") : ""
export const defaultMessage = "ขอบคุณที่ร่วมตอบแบบสอบถาม คุณได้รับ {name}\nรหัส: {code}\nวันหมดอายุ: {expires_at}"

export function parseCouponCodes(text) {
  const codes = text.split(/\r?\n/).map(code => code.trim()).filter(Boolean)
  if (!codes.length) throw new Error("Enter at least one coupon code.")
  if (codes.length > 1000) throw new Error("Import up to 1,000 codes at a time.")
  if (codes.some(code => code.length > 500 || /[\u0000-\u001f\u007f]/.test(code))) throw new Error("Each code must be 500 characters or fewer and contain no control characters.")
  if (new Set(codes).size !== codes.length) throw new Error("Duplicate codes found. Remove duplicates before importing.")
  return codes
}

export function couponPayload(values) {
  if (!values.name.trim()) throw new Error("Enter a coupon name.")
  if (!values.line_campaign_id) throw new Error("Select a LINE campaign.")
  if (!values.message_template.trim().includes("{code}")) throw new Error("The LINE message must contain {code}.")
  if ((values.message_template.match(/\{[^}]*\}/g) || []).some(token => !["{name}", "{code}", "{expires_at}"].includes(token))) throw new Error("Use only {name}, {code} and {expires_at} in the LINE message.")
  const startsAt = values.starts_at ? new Date(values.starts_at) : null
  const expiresAt = values.expires_at ? new Date(values.expires_at) : null
  if ((startsAt && Number.isNaN(startsAt.getTime())) || (expiresAt && Number.isNaN(expiresAt.getTime()))) {
    throw new Error("Enter valid start and expiry dates.")
  }
  if (startsAt && expiresAt && expiresAt <= startsAt) throw new Error("Expiry must be after the start date.")
  return {
    name: values.name.trim(),
    type: values.type,
    entry_channel: values.entry_channel,
    line_campaign_id: Number(values.line_campaign_id),
    description: values.description.trim(),
    message_template: values.message_template.trim(),
    starts_at: startsAt?.toISOString() || null,
    expires_at: expiresAt?.toISOString() || null,
    active: values.active,
  }
}

export function safeEntryUrl(value) {
  try {
    const url = new URL(value)
    return ["http:", "https:"].includes(url.protocol) ? url.toString() : ""
  } catch { return "" }
}
